export default __webpack_public_path__ + "static/media/bird_icon.72a1e471.png";